import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'


interface IProps {
  title: string;
  color?: string;
  classes?: string[];
  noMargin?: boolean;
  size?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AtomTitle',
  props: {
    title: { type: String, required: true },
    color: { type: String, required: false, default: 'var(--color-title)' },
    classes: { type: Array, required: false },
    noMargin: { type: Boolean, required: false },
    size: { type: String, required: false, default: '20px' }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "1c1413fa-size": (_ctx.size)
}))

const props = __props;

const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})